module.exports = __webpack_public_path__ + "static/media/09.53788b5e.png";